export const posts = [
  {
    slug: 'masters63',
    title: 'Masters?',
    date: '02-2026',
    summary: 'Not a bad idea',
    content: [
      `Coming soon...`,
    ]
  },
  {
    slug: 'borealis-lsi',
    title: 'Borealis LSI Track',
    date: '10-2025',
    summary: `We'll take it`,
    content: [
      ` The LSI track is a 2 month program where you work on a project proposed by your team and based on that proposal, RBC Borealis selects the teams that can work on that project under their mentorship.
      The project we submitted was based on the Measles outbreak in Alberta. We spent 10 days researching on what could be done to predict the outbreaks based on various factors like traffic data and previous outbreaks.
      Instead of using traditional ML models, we proposed we used [KANs](https://arxiv.org/abs/2404.19756) (Kolmogorov-Arnold-Networks) to predict the outbreaks. 
      In a nutshell, we proposed KANs because its a type of neural netwrok that has interpretable layers, which we thought would be able to handle multiple features and be able to learn the relationships between them.
      `,

      `We did not come to the conclusion of proposing KANs directly, but we started with a Bayesian Optimization-like approach first because it seemed like a good starting point considering
      I was working with it for sometime now.
      Imagine we want to predict the function that gives us the probability of an outbreak given multiple inputs (say 10 features). We could input multiple entries (each entry contains the 10 features) into the acquisition function of Bayesian Optimization and make it predict 
      more points on the function (UCB/PI/EI).`, ``,
      `This was just an idea that we started with, which led us to using KANs instead of Bayesian Optimization.`, ``,
      `You can find our final report that we submitted [here](https://www.overleaf.com/read/tnbnxzgzknnf#3c6307)`, ``,


      `We submitted our final report on 7th September and heard back from RBC Borealis on September 19th. We were invited for a final interview after which we were told that we were selected for the track.`,
      `Although we were selected, we were not given the opportunity to work on the proposal we submitted, as in the final interview, they told us that RBC was partnering up with other orgs like UNICEF for the first time
      and if we would be interested in working on their project instead of ours.`,
      `Of course we diplomaticaly answered that we wouldn't be opposed to it but we will let them know later.`,
      `Of course we forgot to let them know and then our participation in the track was contigent upon accepting the UNICEF project.`,
      `Fuck it.`,

      `Looking back, I think what happened was for good. Although we didn't get to work on any prediction models directly, we helped them clean the data for one that was in development by students at MIT. We also got to talk 
      to multiple people working at UNICEF; from France, Spain and Germany.`,

      `More coming soon...`
    ]
  },
  {
    slug: 'rl-reward-design-part-2',
    title: `2nd time's the charm`,
    date: '11-2025',
    summary: 'First think inside the box',
    content: [
      `Come April 2025 just before the winter semester was about to end, I wanted to get back into research and finally solve the problem.`,
      `It was a new year with new papers to read. I had gotten pretty comfortable reading scietific papers, so I just got to it. I didn't start coding until I had a good idea of how I wanted
      to attach the problem.`, ``,
      `There were 2 new papers that I had to read because they were the most recent ones that solved the same problem I wanted to solve. The papers were called 
      [EUREKA](https://eureka-research.github.io/) (NVIDIA) and [REvolve](https://openreview.net/forum?id=cJPUpL8mOw) (Orebro University). Although they did not attack the problem of faults, 
      they beat the expert written reward functions in standard environments. EUREKA was more comprehensive in terms of the number of environments they tested their method on (~29) while REvolve
      tested their method on 4 environments.`, ``,
      `The main idea of EUREKA was that if we use an iterative LLM feedback loop to generate reward functions and train using them while giving feedback to the LLM, the LLM would learn to 
      generate better reward functions with each iteration. They provided rich feedback to the LLM so that it understands exactly what to think about.`, ``,

      `REvolve had a similar idea where it used like an evolutionary algorithm to turn reward features on/off and edit them using mutations and crossovers.`, ``,

      `Both of these papers relied on very costly rollouts to evaluate reward functions.`, ``,

      `I asked myself:`,
      `> Can we reduce the number of rollouts? Can we reduce a singlur full rollout to a smaller rollout? Are all the rewards that the LLM gives good enough to be run on a full rollout? 
      Probably not.`,
      `*to be continued*`
    ]
  },

  {
    slug: 'rl-reward-design-part-1',
    title: 'My first research experience',
    date: '05-2024',
    summary: `I'm a bit lost`,
    content: [
      `I started my research experience at the University of Alberta under the supervision of Dr. Osmar R. Zaiane in May 2024. This was the first time I was working on a research project and ngl I was excited.
      I had not taken any research/AI/ML courses at the time (still haven't) so my professor wanted me to focus more on learning the basics of RL before I could dive into the actual project.`,

      `Two months later, when I was done studying RL, I was given the research topic of reward shaping/design for fault-tolerant control. My professor gave me the following analogy:`,

      `>Imagine we send a robot to Mars and we want it to be able to navigate to a target destination, or complete a fixed task (for example, collect ground samples). What if a rock hits the robot or sand interferes with the 
      working of the gears of the robot? What if the robot breaks a leg? How do we make sure it completes the task it is assigned despite these obstacles? Moreover, how can we
      make changes to the reward function to make it resilient to these out-of-distribution scenarios?`,

      `I was immediately hooked. I knew this was something I wanted to work on and I knew this would have a huge impact on the field of robotics.
      I started on the project by reading related literature and the Text2Reward paper that was published at ICLR 2024 at the time. It felt a bit daunting at first reading the papers, as the people publishing them
      were Masters and PhD students from top universities and companies like CMU and Microsoft.`, ``,

      `I started out with the pre-made repository that one of the PhD students made where they had multiple [Gymnasium(MuJoCo)](https://gymnasium.farama.org/environments/mujoco/) environments already 
      configued with [Proximal Policy Optimization (PPO)](https://arxiv.org/abs/1707.06347). I integrated a simple LLM loop that would give a different reward function for the new faulty environemnt 
      given the expert gymnasium reward function.`,

      `This was simple, but a bit too simple. Another problem that I encountered was that the environment we selected was too simple to see any improvements, atleast with the LLM given reward functions. 
      It was the [FetchReach](https://robotics.farama.org/envs/fetch/reach/) environment, who's expert reward function was the negative of the distance between the end effector and the target. Most of my time went in understanding the 
      present codebase and understand the Gymnasium API. I later got to know that my professor was expecting me to publish a paper, but I had no findings.`,

      `Although my professor did not pressure me into publishing a paper at the end of my 4 month internship (he knew 4 months was too less for an UGrad to publish), we both were happy that I was able to learn 
      so much in 4 months.`, ``,

      `Our research group was funded by MELCO (Mitsubishi Electric Corporation, Japan) so we used to have monthly update meetings with them which was pretty cool. They even came to Edmonton to visit us. 
      It was a great experience and I learned a lot from them.`, ``,

      `One common thing that I noticed in all of these senior researchers including my professor was that they spent a lot of time thinking about ideas.`,

      `>What if we add noise to the reward function? Or what if we change the weights a bit? Is it going to affect the task? What if we use a human in the loop? Do we actually require a human in the loop? 
      Do all running/locomotion tasks use the same principle reward function? What is the maximum amount of difference between a normal & a faulty environment so that those two envs can be considered similar enough?`, ``,

      `Essentially, they gave themselves ample time to think before building something. It is obvious, but the level at which this was happening was something I had not seen as an engineer before.`, ``,

      `My term came to an end at the end of August and I continued my studies at the university while also working as a Teaching Assistant.`
     ]
  }
];
